import { createContext, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar/Navbar.jsx";
import ProtectedRoute from "./Components/ProtectedRoute.js";
import SideBar from "./Components/Sidebar/Sidebar.jsx";
import Login from "./pages/loginRegister/Login.jsx";
import Operators from "./pages/Operators/Operators.jsx";
import Overview from "./pages/overview/Overview.jsx";
import Services from "./pages/ServiceList/Services.jsx";
import Transactions from "./pages/Transactions/Transactions.jsx";
import AddUser from "./pages/Users/AddUser.jsx";
import EditUser from "./pages/Users/EditUser.jsx";
import UsersList from "./pages/Users/UsersList.jsx";
import AddCredit from "./pages/Wallet/AddDebitCredit.jsx";
import WalletSummary from "./pages/Wallet/WalletSummary.jsx";
import { login } from "./store/authSlice.js";
import { getUser } from "./store/userSlice.js";
import Profile from "./pages/AdminProfile/Profile.jsx";
import EditProfile from "./pages/AdminProfile/EditProfile.jsx";
import ChangePassword from "./pages/Settings/ChangePassword.jsx";
import Verification from "./pages/Users/Verification.jsx";
import OtpVerification from "./pages/Users/OtpVerification.jsx";
import MobileVerificationMsg from "./pages/Users/MobileVerificationMsg.jsx";
import BiometricVerification from "./pages/Users/BiometricVerification.jsx";
import FingerPrint from "./pages/Users/FingerPrint.jsx";
import FingerPrintMsg from "./pages/Users/FingerPrintMsg.jsx";
import RechrageCommission from "./pages/Settings/RechrageCommission.jsx";
import BBPSRechargeCommission from "./pages/Settings/BBPSRechargeCommission.jsx";
import NewSubadmin from "./pages/NewMember/NewSubadmin.jsx";
import FreeMemberIdPlan from "./pages/NewMember/FreeMemberIdPlan.jsx";
import AddNewMember from "./pages/NewMember/AddNewMember.jsx";
import MemberList from "./pages/NewMember/MemberList.jsx";

import BankDetails from "./pages/NewMember/BankDetails.jsx";
import EditService from "./pages/ServiceList/EditService.jsx";
import EditOperator from "./pages/Operators/EditOperator.jsx";
import MerchantCommissionList from "./pages/NewMember/MerchantCommissionList.jsx";
import AddNewMerchant from "./pages/NewMember/AddNewMerchant.jsx";
import HelpandSupport from "./pages/Help&Support/HelpandSupport.jsx";
import EditHelpSupport from "./pages/Help&Support/EditHelpSupport.jsx";
import CreateTicket from "./pages/TicketManagement/CreateTicket.jsx";
import TicketList from "./pages/TicketManagement/TicketList.jsx";
import ViewTicket from "./pages/TicketManagement/ViewTicket.jsx";
import PermissionManagement from "./pages/NewMember/RoleManagmentAndPermission/PermissionManagement.jsx";
import { getUserAccount } from "./utils/api.js";
import DebitCreditList from "./pages/Wallet/DebitCreditList.js";
import ApiPermission from "./pages/NewMember/ApiPermissionManagement/ApiPermission.jsx";
import PackageManagementList from "./pages/NewMember/PackageMnagement/PackageList.jsx";
import SelectPackage from "./pages/Users/SelectPackeg.jsx";
import CreatePackage from "./pages/NewMember/PackageMnagement/ManagePackage.jsx";
import Service from "./pages/NewMember/PackageMnagement/Service.jsx";
import RetailerList from "./pages/Users/RetailerList.jsx";
import PaymentReceive from "./pages/PaymentReceive/PaymentReceive.jsx";
import Invoice from "./pages/Wallet/Invoice.jsx";
import Vendor from "./pages/Vendor/Vendor.jsx";
import VendorTransaction from "./pages/Vendor/VendorTransaction.jsx";
import AddVendor from "./pages/Vendor/AddVendor.jsx";
import ManageFundRequest from "./pages/Vendor/ManageFundRequest.jsx";
import VenderBalance from "./pages/Dashboard/VenderBalance.jsx";
import DeviceInfoList from "./pages/DeviceInfo/DeviceInfoList.jsx";
import AddDevice from "./pages/DeviceInfo/AddDevice.jsx";
import DeviceMapping from "./pages/DeviceInfo/DeviceMapp.jsx";
import AssignedDeviceList from "./pages/DeviceInfo/AssignedDeviceList.jsx";
import ServicesRoute from "./pages/NewMember/PackageMnagement/ServicesRoute.jsx";
import CDMCardInventory from "./pages/CDMCardInventory/CDMCardInventory.jsx";
import AddCard from "./pages/CDMCardInventory/AddCard.js";
import CdmMaped from "./pages/CDMCardInventory/CdmMaped.jsx";
import CdnDeviceMapp from "./pages/CDMCardInventory/CdnDeviceMapp.jsx";
import DQECardInventory from "./pages/DQRCardInventory/DQECardInventory.jsx";
import DQRDeviceMapp from "./pages/DQRCardInventory/DQRDeviceMapp.jsx";
import DQRMaped from "./pages/DQRCardInventory/DQRMaped.jsx";
import AddDqrCard from "./pages/DQRCardInventory/AddDqrCard.js";
import HotelList from "./pages/Travel/Hotel/HotelList.jsx";
import CityList from "./pages/Travel/Hotel/cityList.jsx";
import CountryList from "./pages/Travel/Hotel/CountryList.jsx";

import ViewCityDetails from "./pages/Travel/Hotel/ViewCity.jsx";
import ViewHotelDetails from "./pages/Travel/Hotel/ViewHotel.jsx";
import ViewCountryDetails from "./pages/Travel/Hotel/ViewCountry.js";
import ViewHotelImageDetails from "./pages/Travel/Hotel/ViewHotelImage.jsx";
import AirlineList from "./pages/Travel/Flight/AirlineList.jsx";
import AirportList from "./pages/Travel/Flight/AirportList.jsx";
import ViewAirlineDetails from "./pages/Travel/Flight/ViewAirline.jsx";
import viewAirPort from "./pages/Travel/Flight/ViewAirport.jsx";
import ViewAirportDetails from "./pages/Travel/Flight/ViewAirport.jsx";
import AddHotel from "./pages/Travel/Hotel/AddNewHotel.js";
import AddCity from "./pages/Travel/Hotel/AddCity.js";
import AddCountry from "./pages/Travel/Hotel/AddCountry.js";
import AddAirline from "./pages/Travel/Flight/AddAirline.js";
import AddNewAirline from "./pages/Travel/Flight/AddAirline.js";
import AddNewAirport from "./pages/Travel/Flight/AddAirport.js";
import BulkWalletBalance from "./pages/BulkWalletBalance/BulkWalletBalance.jsx";
import ReferralUser from "./pages/Users/ReferralUser.jsx";
import AddReferralUser from "./pages/Users/AddReferralUser.jsx";
import BookingList from "./pages/Travel/BookingList/BookingList.jsx";
import B2CTransactions from "./pages/B2CUsers/B2CTransactions.jsx";
import B2cUsers from "./pages/B2CUsers/B2cUsers.jsx";
import ManagedServices from "./pages/ManagedServices/ManagedServices.jsx";
import TenantVerificationForm from "./Components/TenantVerificationForm/TenantVerificationForm.jsx";
import NyraRentalForm from "./Components/TenantVerificationForm/NyraRentalForm.jsx";

import RentalManager from "./pages/Rentalmanagement/RentalManager.jsx";
import PgList from "./pages/Rentalmanagement/PgList.jsx";
// import AddPg from "./pages/Rentalmanagement/AddPg.jsx";
import AddPg from "./pages/Rentalmanagement/AddPg.jsx";
import TenantKyc from "./pages/Rentalmanagement/TenantKyc.jsx";
import Footer from "./Components/Footer/Footer.jsx";
import RentAgreementFormat from "./Components/TenantVerificationForm/RentAgreementFormat.jsx";
import PssswordExp from "./pages/loginRegister/PssswordExp.jsx";
import NotFound from "./pages/NotFound/NotFound.jsx";
import Analyse from "./pages/Report/Analyse.jsx"
import PermissionWrapper from "./Components/PermissionWrapper/PermissionWrapper.jsx";
import TidReport from "./pages/Report/TidReport.jsx";
import LogPage from "./pages/Report/LogPage.jsx";
export const UserContextData = createContext();
function App() {
  const dispatch = useDispatch();

  const [isAuth, setIsAuth] = useState(null);
  let auth = JSON.parse(sessionStorage.getItem("token"));
  let authData = useSelector((state) => state.auth.auth);
  const [isOpen, setIsOpen] = useState(true);
  const [permission, setPermission] = useState([]);
  const [siedBarLeft, setSiedBarLeft] = useState("");
  const [permissionLoader, setPermissionLoader] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (auth) {
      dispatch(login(auth));
      setIsAuth(true);
    } else {
      setIsAuth(false);
    }

    if (process.env.NODE_ENV === "production") {
      console.log = () => {};
      console.error = () => {};
      console.warn = () => {};
    }
  }, []);

  const handleUserData = async () => {
    if (authData) {
          setLoading(true)
      getUserAccount().then((resp) => {
         setLoading(false)
        let userInfo = resp?.data?.data;

        dispatch(getUser(userInfo));
      }).catch(()=>{
        setLoading(false)
      })
    }
  };



  useEffect(() => {
    handleUserData();
  }, [authData]);

  const expTime = () => {
    const timeOut = setTimeout(() => {
      const time = sessionStorage.getItem("timer");
      if (time > 0) {
        sessionStorage.setItem("timer", parseInt(time) - 1);

        expTime();
      } else {
        clearTimeout(timeOut);
        sessionStorage.clear();
      }
    }, 1000);
  };

  return (
    <BrowserRouter>
      
      {!auth && (
        <Routes>
            <Route path="/" element={<Login />} />
          {/* <Route path="/password-exp" element={<PssswordExp />} /> */}
          <Route path="*" element={<NotFound />} />
           {/* <Route
                      path="/changePassword"
                      element={<ProtectedRoute Component={ChangePassword} />}
                    /> */}
     
      
     
        </Routes>
      )}

      {authData && (
        <UserContextData.Provider>
          <SideBar
            siedBarLeft={siedBarLeft}
            setSiedBarLeft={setSiedBarLeft}
            setPermission={setPermission}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            setPermissionLoader={setPermissionLoader}
          >
            <main className={`${isOpen ? "main_off" : "main_on"} `} style={{display:"flex",justifyContent:"space-between",flexDirection:"column"}}>
               <div>
                  <Navbar
                setSiedBarLeft={setSiedBarLeft}
                permission={permission}
                // setUpdateData={setUpdateData} upadteData={upadteData}
              />

              <Routes>
                <Route
                  path="/"
                  element={
                    <ProtectedRoute
                      Component={Overview}
                      permission={permission}
                    />
                  }
                />
                {permission.includes("MANAGE_USERS") && (
                  <>
                    <Route
                      path="/usersList"
                      element={<ProtectedRoute Component={UsersList} />}
                    />
                  </>
                )}
                {permission.includes("MANAGE_USERS") && (
                  <>
                    <Route
                      path="/hotel/hotellist"
                      element={<ProtectedRoute Component={HotelList} />}
                    />
                  </>
                )}
                {permission.includes("MANAGE_USERS") && (
                  <>
                    <Route
                      path="/hotel/addhotel"
                      element={<ProtectedRoute Component={AddHotel} />}
                    />
                  </>
                )}
                {permission.includes("MANAGE_USERS") && (
                  <>
                    <Route
                      path="/hotel/cities"
                      element={<ProtectedRoute Component={CityList} />}
                    />
                  </>
                )}
                {permission.includes("MANAGE_USERS") && (
                  <>
                    <Route
                      path="/hotel/addCity"
                      element={<ProtectedRoute Component={AddCity} />}
                    />
                  </>
                )}
                {permission.includes("MANAGE_USERS") && (
                  <>
                    <Route
                      path="/hotel/view/cities/:id"
                      element={<ProtectedRoute Component={ViewCityDetails} />}
                    />
                  </>
                )}
                {permission.includes("MANAGE_USERS") && (
                  <>
                    <Route
                      path="/hotel/view/hotel/:id"
                      element={<ProtectedRoute Component={ViewHotelDetails} />}
                    />
                  </>
                )}
                {permission.includes("MANAGE_USERS") && (
                  <>
                    <Route
                      path="/hotel/view/Country/:id"
                      element={
                        <ProtectedRoute Component={ViewCountryDetails} />
                      }
                    />
                  </>
                )}
                {permission.includes("MANAGE_USERS") && (
                  <>
                    <Route
                      path="/hotel/countries"
                      element={<ProtectedRoute Component={CountryList} />}
                    />
                  </>
                )}
                {permission.includes("MANAGE_USERS") && (
                  <>
                    <Route
                      path="/hotel/addCountry"
                      element={<ProtectedRoute Component={AddCountry} />}
                    />
                  </>
                )}
                {permission.includes("MANAGE_USERS") && (
                  <>
                    <Route
                      path="/flight/airlinesList"
                      element={<ProtectedRoute Component={AirlineList} />}
                    />
                  </>
                )}
                {permission.includes("MANAGE_USERS") && (
                  <>
                    <Route
                      path="/flight/addAirline"
                      element={<ProtectedRoute Component={AddNewAirline} />}
                    />
                  </>
                )}
                {permission.includes("MANAGE_USERS") && (
                  <>
                    <Route
                      path="/flight/addnewairport"
                      element={<ProtectedRoute Component={AddNewAirport} />}
                    />
                  </>
                )}
                {permission.includes("MANAGE_USERS") && (
                  <>
                    <Route
                      path="/flight/airportList"
                      element={<ProtectedRoute Component={AirportList} />}
                    />
                  </>
                )}
                {permission.includes("MANAGE_USERS") && (
                  <>
                    <Route
                      path="/flight/airportList"
                      element={<ProtectedRoute Component={AirportList} />}
                    />
                  </>
                )}
                {permission.includes("MANAGE_USERS") && (
                  <>
                    <Route
                      path="/flight/view/airport/:id"
                      element={
                        <ProtectedRoute Component={ViewAirportDetails} />
                      }
                    />
                  </>
                )}
                {permission.includes("MANAGE_USERS") && (
                  <>
                    <Route
                      path="/flight/view/airline/:id"
                      element={
                        <ProtectedRoute Component={ViewAirlineDetails} />
                      }
                    />
                  </>
                )}
                <>
                    <Route
                      path="/bookinglist"
                      element={<ProtectedRoute Component={BookingList} />}
                    />
                  </>
                {permission.includes("MANAGE_RETAILER") ? (
                  <>
                    <Route
                      path="/retailerList"
                      element={
                        <ProtectedRoute
                          Component={RetailerList}
                          permission={permission}
                        />
                      }
                    />
                  </>
                ) : (
                  <>
                    <Route
                      path="/"
                      element={
                        <ProtectedRoute
                          Component={Overview}
                          permission={permission}
                        ></ProtectedRoute>
                      }
                    />
                  </>
                )}

                <Route
                  path="/addnewmember"
                  element={<ProtectedRoute Component={AddNewMember} />}
                />
                <Route
                  path="/memberlist"
                  element={<ProtectedRoute Component={MemberList} />}
                />
            
                <Route
                  path="/newsubadmin"
                  element={<ProtectedRoute Component={NewSubadmin} />}
                />
                <Route
                  path="/freememberidplan"
                  element={<ProtectedRoute Component={FreeMemberIdPlan} />}
                />
                <Route
                  path="/merchantcommissionlist"
                  element={
                    <ProtectedRoute Component={MerchantCommissionList} />
                  }
                />

                {permission.includes("ROLE_PERMISSION_API") && (
                  <>
                    <Route
                      path="/permisionManagement"
                      element={
                        <ProtectedRoute Component={PermissionManagement} />
                      }
                    />
                  </>
                )}

                {permission.includes("ROLE_PERMISSION_API") && (
                  <>
                    <Route
                      path="/ApiPermisionManagement"
                      element={<ProtectedRoute Component={ApiPermission} />}
                    />
                  </>
                )}

                {permission.includes("MANAGE_PACKAGE_LIST") && (
                  <>
                    <Route
                      path="/PackageMnagementList"
                      element={
                        <ProtectedRoute Component={PackageManagementList} />
                      }
                    />
                  </>
                )}
                {permission.includes("ADD_MANAGE_PACKAGE") && (
                  <>
                    <Route
                      path="/CreatePackage"
                      element={<ProtectedRoute Component={CreatePackage} />}
                    />
                  </>
                )}
                {permission.includes("ADD_MANAGE_PACKAGE") && (
                  <>
                    <Route
                      path="/service"
                      element={<ProtectedRoute Component={Service} />}
                    />
                  </>
                )}

                <Route
                  path="/addnewmerchant"
                  element={<ProtectedRoute Component={AddNewMerchant} />}
                />

                {permission.includes("ADD_MEMBER") && (
                  <>
                    <Route
                      path="/addUser"
                      element={<ProtectedRoute Component={AddUser} />}
                    />
                  </>
                )}
                {permission.includes("MANAGE_USERS_EDIT") && (
                  <>
                    <Route
                      path="/editUser"
                      element={<ProtectedRoute Component={EditUser} />}
                    />
                  </>
                )}
                {/* <Route
                path="/featuremanagement"
                element={<ProtectedRoute Component={FeatureManagement} />}
              /> */}
                {/* <Route
                path="/addnewservice"
                element={<ProtectedRoute Component={AddNewService} />}
              /> */}
                {permission.includes("CREDIT/DEDUCT") && (
                  <>
                    <Route
                      path="/addcredit"
                      element={<ProtectedRoute Component={AddCredit} />}
                    />
                  </>
                )}
                {permission.includes("CREDIT/DEDUCT") && (
                  <>
                    <Route
                      path="/deposit"
                      element={<ProtectedRoute Component={PaymentReceive} />}
                    />
                  </>
                )}

                {permission.includes("WALLET") &&
                permission.includes("WALLET_SUMMARY_ACTION") ? (
                  <>
                    <Route
                      path="/DebitCreditList"
                      element={
                        <ProtectedRoute
                          Component={DebitCreditList}
                          permission={permission}
                        />
                      }
                    />
                  </>
                ) : (
                  <>
                    <Route
                      path="/"
                      element={
                        <ProtectedRoute
                          Component={Overview}
                          permission={permission}
                        ></ProtectedRoute>
                      }
                    />
                  </>
                )}
                {permission.includes("TRANSACTION") && (
                  <>
                    <Route
                      path="/transactions"
                      element={<ProtectedRoute Component={Transactions} />}
                    />
                    <Route
                      path="/transactions/:invoice"
                      element={<ProtectedRoute Component={Invoice} />}
                    />
                  </>
                )}
                {permission.includes("OPERATOR_LIST") && (
                  <>
                    <Route
                      path="/operators"
                      element={<ProtectedRoute Component={Operators} />}
                    />
                  </>
                )}
                <Route
                  path="/editoperatorList"
                  element={<ProtectedRoute Component={EditOperator} />}
                />

                <Route
                  path="/serviceList"
                  element={<ProtectedRoute Component={Services} />}
                />

                <Route
                  path="/editserviceList"
                  element={<ProtectedRoute Component={EditService} />}
                />
                {permission.includes("WALLET_SUMMARY") && (
                  <>
                    <Route
                      path="/walletTransactions"
                      element={<ProtectedRoute Component={WalletSummary} />}
                    />
                    <Route
                      path="/walletTransactions/:invoice"
                      element={<ProtectedRoute Component={Invoice} />}
                    />
                  </>
                )}
                <Route
                  path="/profile"
                  element={<ProtectedRoute Component={Profile} />}
                />
                <Route
                  path="/editProfile"
                  element={<ProtectedRoute Component={EditProfile} />}
                />
                {permission.includes("CHANGE_PASSWORD") && (
                  <>
                    <Route
                      path="/changePassword"
                      element={<ProtectedRoute Component={ChangePassword} />}
                    />
                  </>
                )}
                <Route
                  path="/rechargecommission"
                  element={<ProtectedRoute Component={RechrageCommission} />}
                />

                <Route
                  path="/bbpsrechargecommision"
                  element={
                    <ProtectedRoute Component={BBPSRechargeCommission} />
                  }
                />
                <Route
                  path="/verification"
                  element={<ProtectedRoute Component={Verification} />}
                />

                <Route
                  path="/otpverification"
                  element={<ProtectedRoute Component={OtpVerification} />}
                />
                <Route
                  path="/mobilverificationmsg"
                  element={<ProtectedRoute Component={MobileVerificationMsg} />}
                />
                <Route
                  path="/biometricverification"
                  element={<ProtectedRoute Component={BiometricVerification} />}
                />
                {/* <Route
                                path="/fingerprint"
                                element={
                                    <ProtectedRoute Component={FingerPrint} />
                                }
                            /> */}
                <Route
                  path="/fingerprintmsg"
                  element={<ProtectedRoute Component={FingerPrintMsg} />}
                />
                <Route
                  path="/bankdetails"
                  element={<ProtectedRoute Component={BankDetails} />}
                />

                <Route
                  path="/helpandsupport"
                  element={<ProtectedRoute Component={HelpandSupport} />}
                />
                <Route
                  path="/edithelpandsupport"
                  element={<ProtectedRoute Component={EditHelpSupport} />}
                />
                <Route
                  path="/createticket"
                  element={<ProtectedRoute Component={CreateTicket} />}
                />
                <Route
                  path="/ticketList"
                  element={<ProtectedRoute Component={TicketList} />}
                />

                <Route
                  path="/viewticket"
                  element={<ProtectedRoute Component={ViewTicket} />}
                />
                <Route
                  path="/select-package"
                  element={<ProtectedRoute Component={SelectPackage} />}
                />
                <Route
                  path="/permissionManagement"
                  element={<ProtectedRoute Component={PermissionManagement} />}
                />
                {permission.includes("POS") && (
                  <>
                    <Route
                      path="/device-info"
                      element={<ProtectedRoute Component={DeviceInfoList}    permission={permission} />}
                    />
                    <Route
                      path="/add-device"
                      element={<ProtectedRoute Component={AddDevice} />}
                    />
                    <Route
                      path="/add-card"
                      element={<ProtectedRoute Component={AddCard} />}
                    />
                    <Route
                      path="/map-device"
                      element={<ProtectedRoute Component={DeviceMapping} />}
                    />
                    <Route
                      path="/assign-device"
                      element={
                        <ProtectedRoute Component={AssignedDeviceList} />
                      }
                    />
                  </>
                )}
                <Route
                  path="/vendor-list"
                  element={<ProtectedRoute Component={Vendor} />}
                />
                <Route
                  path="/vendor-transaction"
                  element={<ProtectedRoute Component={VendorTransaction} />}
                />
                <Route
                  path="/vendor-transaction/:txn"
                  element={<ProtectedRoute Component={Invoice} />}
                />
                <Route
                  path="/addVendor"
                  element={<ProtectedRoute Component={AddVendor} />}
                />
                <Route
                  path="/vendor-fund-request"
                  element={<ProtectedRoute Component={ManageFundRequest} />}
                />
                <Route
                  path="/vendor-balance"
                  element={<ProtectedRoute Component={VenderBalance} />}
                />
                <Route
                  path="/services-route"
                  element={<ProtectedRoute Component={ServicesRoute} />}
                />
                {
                  permission.includes("CDM")
                  &&<>
                   <Route
                  path="/cdm-card-nventory"
                  element={<ProtectedRoute Component={CDMCardInventory} />}
                />

                <Route
                  path="/cdm-assign-device"
                  element={<ProtectedRoute Component={CdmMaped} />}
                />
                <Route
                  path="/map-cdm-device"
                  element={<ProtectedRoute Component={CdnDeviceMapp} />}
                />
                  </>
                }
               
             {permission.includes("DQR") &&
              <>
                 <Route
                  path="/dqr-inventory"
                  element={<ProtectedRoute Component={DQECardInventory} />}
                />
                <Route
                  path="/dqr-assign-device"
                  element={<ProtectedRoute Component={DQRMaped} />}
                />
                <Route
                  path="/add-dqr-card"
                  element={<ProtectedRoute Component={AddDqrCard} />}
                />
                <Route
                  path="/mapp-dqr-device"
                  element={<ProtectedRoute Component={DQRDeviceMapp} />}
                />
              </>
             }
                <Route
                  path="/bulk-transfer"
                  element={<ProtectedRoute Component={BulkWalletBalance} />}
                />
                <Route
                  path="/referral-users"
                  element={<ProtectedRoute Component={ReferralUser} />}
                />
                {permission.includes("ADD_MEMBER") && (
                  <>
                    <Route
                      path="/add-referral-user"
                      element={<ProtectedRoute Component={AddReferralUser} />}
                    />
                  </>
                )}
                <Route
                  path="/b2c-users"
                  element={<ProtectedRoute Component={B2cUsers} />}
                />
                <Route
                  path="/b2c-transaction"
                  element={<ProtectedRoute Component={B2CTransactions} />}
                />
                <Route
                  path="/b2c-transaction/:txn"
                  element={<ProtectedRoute Component={Invoice} />}
                />
                <Route
                  path="/managed-services"
                  element={<ProtectedRoute Component={ManagedServices} />}
                />
                <Route
                  path="/police-verification-form"
                  element={<ProtectedRoute Component={TenantVerificationForm} />}
                />
                <Route
                  path="/rental-form"
                  element={<ProtectedRoute Component={NyraRentalForm } />}
                />
                <Route
                  path="/rental-manager"
                  element={<ProtectedRoute Component={RentalManager} />}
                />
                <Route
                  path="/pg-list"
                  element={<ProtectedRoute Component={PgList} />}
                />
                <Route
                  path="/Add-pg"
                  element={<ProtectedRoute Component={AddPg} />}
                />
                <Route
                  path="/Add-room"
                  element={<ProtectedRoute Component={TenantKyc} />}
                />
                     <Route path="/rent-aggrement-format" element={<RentAgreementFormat />} />
                      <Route
                  path="/report/analyse"
                  element={<PermissionWrapper>
                    <ProtectedRoute Component={Analyse} />
                  </PermissionWrapper>}
                />
                      <Route
                  path="/report/tid"
                  element={<PermissionWrapper>
                    <ProtectedRoute Component={TidReport} />
                  </PermissionWrapper>}
                />

                   <Route
                  path="/transaction/logs"
                  element={<ProtectedRoute Component={LogPage} />}
                />
                      <Route path="*" element={<NotFound loading={permissionLoader || loading} />} />

              </Routes>
               </div>
              <Footer />
            </main>
          </SideBar>
        </UserContextData.Provider>
      )}
    </BrowserRouter>
  );
}
export default App;
